let prefetched = false;

export function prefetchBestPropFirmsPage() {
  if (prefetched) return;
  void import('../pages/BestPropFirmsPage');
  prefetched = true;
}
